var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"example zero-card p-x2"},[_c('h4',[_vm._v(_vm._s(_vm.titleProp))]),_c('p',[_vm._v("\n    "+_vm._s(_vm.descProp)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }